// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tsJ5","toggle":"styles_toggle__3XwU_","preview":"styles_preview__H3Foc"};